import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import SideBar from "../../components/SideBar/SidedBar";
import AdminCadastroImovel from "../../components/AdminCadastroImovel/AdminCadastroImovel";
import ConsultarImoveis from "../../components/ConsultarImoveis/ConsultarImoveis";
import CadastroAdmin from "../../components/CadastroAdmin/CadastroAdmin";
import AlterarSenha from "../../components/AlterarSenha/AlterarSenha";
import { obterConta, removerToken } from "../../services/api";
import styles from "./AdminHome.module.css";

export default function AdminHome() {
  const [secao, setSecao] = useState('consultar');
  const navigate = useNavigate();
  const conta = obterConta();

  const handleLogout = () => {
    removerToken();
    navigate('/admin');
  };

  return (
    <>
      <Header />
      <div className={styles.layout}>
        <SideBar onSelect={setSecao} onLogout={handleLogout} />
        <main className={styles.conteudo}>
          <section className={styles.sessaoConta}>
            <div>
              <strong>Conta logada:</strong> {conta?.nome || 'Usuario'} ({conta?.email || 'sem email'})
            </div>
            <span className={`${styles.badgeRole} ${conta?.role === 'admin' ? styles.badgeRoleAdmin : styles.badgeRoleCliente}`}>
              {conta?.role || 'cliente'}
            </span>
          </section>

          {secao === 'cadastrar' && <AdminCadastroImovel />}
          {secao === 'consultar' && <ConsultarImoveis />}
          {secao === 'admins' && <CadastroAdmin />}
          {secao === 'senha' && <AlterarSenha />}
        </main>
      </div>
      <Footer />
    </>
  );
}